<div class="middle-box text-center loginscreen  animated fadeInDown">
    <h2 class="logo-name">Genesis Trailers</h2>
    <div style="margin-top: 25px;">client version: {{ appInfo.clientVersion }}</div>
    <div style="margin-top: 5px;">service version: {{ appInfo.serviceVersion }}</div>
</div>

<div style="margin-top: 100px; margin-left: 50px;"><a href (click)="logout()">log out</a></div>
